import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import { Cross } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

const FooterRatingBar = ({ setIsRatingBarOpen, onClick }) => {
  const isExpanded = useSelector((state) => state?.sidebarNav?.isExpanded);

  return (
    <Container isExpanded={isExpanded} onClick={onClick}>
      <Flex justifyContent="center" alignItems="center" pl="20%">
        <TextLabel>On a scale of 1-5, how beneficial was your 1:1 meeting today?</TextLabel>
        <Button variant="tertiary">Rate this 1:1</Button>
      </Flex>

      <Button
        sx={{
          marginTop: '4px',
          marginLeft: 'auto',
          svg: {
            color: '#333333 !important',
          },
        }}
        onClick={() => setIsRatingBarOpen(false)}
        variant="tertiary"
        EndIcon={Cross}
      />
    </Container>
  );
};

export default FooterRatingBar;

const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 0px 10px;
  height: 48px;
  background:
    linear-gradient(
      132deg,
      rgba(0, 142, 240, 0.03) 0%,
      rgba(236, 59, 100, 0.03) 33.65%,
      rgba(255, 194, 0, 0.03) 64.9%,
      rgba(92, 196, 97, 0.03) 100%
    ),
    #fff;

  position: fixed;
  bottom: 0;
  right: 0;
  left: ${(props) => (props.isExpanded ? '16.7%' : '1%')};
  border-top: 1px solid #d6e7f9;
  cursor: pointer;
`;
